import { apiClient } from './client'
import type { LoginRequest, LoginResponse, User, AccountType } from '../types'

export interface IGCredentialsSet {
  api_key: string
  username: string
  password: string
  account_type: AccountType
}

export interface IGCredentialsStatus {
  has_credentials: boolean
  account_type?: AccountType
}

export const authApi = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const formData = new URLSearchParams()
    formData.append('username', credentials.username)
    formData.append('password', credentials.password)

    const response = await apiClient.post<LoginResponse>('/auth/login', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
    return response.data
  },

  register: async (data: { email: string; username: string; password: string }): Promise<User> => {
    const response = await apiClient.post<User>('/auth/register', data)
    return response.data
  },

  getCurrentUser: async (): Promise<User> => {
    const response = await apiClient.get<User>('/auth/me')
    return response.data
  },

  setIGCredentials: async (credentials: IGCredentialsSet): Promise<IGCredentialsStatus> => {
    const response = await apiClient.post<IGCredentialsStatus>('/auth/ig-credentials', credentials)
    return response.data
  },

  getIGCredentialsStatus: async (): Promise<IGCredentialsStatus> => {
    const response = await apiClient.get<IGCredentialsStatus>('/auth/ig-credentials/status')
    return response.data
  },

  deleteIGCredentials: async (): Promise<void> => {
    await apiClient.delete('/auth/ig-credentials')
  },
}
